/* eslint-disable */
import {
  Layout,
  Card,
  Typography,
  Button,
  Space,
  Flex,
  Dropdown,
  Spin,
  Modal,
  message
} from "antd";

import React, { useEffect, useState, useRef } from "react";
import api from "@/utils/api";
import http from "@/utils/http";
import EnhancedTable from "@/hocComponents/EnhancedTable";
import {
  MenuOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/AddModal";
import EditModal from "./component/EditModal";
export default function DashboardRequest() {
  const { Header, Content } = Layout;
  const { Title } = Typography;
  const addModalRef = useRef(null);
  const editModalRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading,setSubmitLoading]= useState(false);
  const showModalAdd = () => {
    addModalRef.current?.setModelAdd();
  };

  useEffect(() => {
    fetchTable();
  }, []);

  const handleMenuClick = async (e, record) => {
    if (e.key === "edit") {
      editModalRef.current?.open(record);
    }if (e.key === "delete") {
    handleDelete(record);
    }
  };
  const fetchTable = async () => {
    setLoading(true);
    try {
      const res = await http.get(api.getEmployeesTableList);
      const list = res?.data || [];
      // 按 allowanceType 分组
      const groupedData = list.reduce((acc, item, idx) => {
        const type = item.allowanceType;

        if (!acc[type]) {
          acc[type] = [];
        }

        acc[type].push({
          ...item,
          index: acc[type].length + 1,
          key: item.id,
        });

        return acc;
      }, {});

      setTableData(groupedData);
    } catch (err) {
      console.error("fetchTable error:", err);
      setTableData({});
    } finally {
      setLoading(false);
    }
  };


const handleDelete = (record) => {
  Modal.confirm({
    title: "Are you sure you want to delete this record?",
    content: `Name: ${record.allowanceName}`,
    okText: "Submit",
    cancelText: "No",
    centered: true,

    onOk: () => {
      setSubmitLoading(true);
      return http
        .get(api.getEmployeesTimeDelete, {
          params: { id: record.id },
        })
        .then((res) => {
          if (res?.code === "1") {
            message.success("Deleted successfully.");
            fetchTable();
          } else {
            message.error(res?.msg || "Delete failed");
            return Promise.reject();
          }
        })
        .catch((err) => {
          console.error(err);
          message.error("Request failed, please try again");
          return Promise.reject();
        })
        .finally(() => {
          setSubmitLoading(false);
        });
    },
  });
};


  const columns = [
    // {
    //   title: "#",
    //   dataIndex: "index",
    //   width: 50,
    //   align: "center",
    // },
    {
      title: "Action",
      dataIndex: "id",
      align: "center",
      width: 60,
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "edit",
                icon: (
                  <EditOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
                ),
                label: <div>Edit View</div>,
              },
                  {
                key: "delete",
                icon: (
                  <DeleteOutlined  style={{ color: "#00c0ef", fontSize: 17 }} />
                ),
                label: <div>Delete</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined
            style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
          />
        </Dropdown>
      ),
    },
    // {
    //   title: "Code",
    //   dataIndex: "allowanceCode",
    //   width: 120,
    // },

    // {
    //   title: "Type",
    //   dataIndex: "allowanceType",
    //   width: 120,
    // },
        {
      title: "AllowanceName",
      dataIndex: "allowanceName",
      width: 120,
    },
       {
      title: "Amount",
      dataIndex: "amount",
        width: 120,
         isBracketAmountFlag: true,
    },
    {
      title: "Hours",
      dataIndex: "hours",
      width: 120,
    },
    {
      title: "Remark",
      dataIndex: "remark",
      width: 120,
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      render: (v) => (v === 1 ? "Enable" : "Disable"),
    },
  ];

  return (
    <div className="dashboard-layout">
      <Content style={{ marginTop: 10 }}>
          <Flex className="topDiv" justify="space-between" align="flex-start">
            <div>
              {(commonFn.btnAuthorityFlag("New") && (
                <Space size="large">
                  <Button className="btnNew" onClick={showModalAdd}>
                    <PlusOutlined />
                    New
                  </Button>
                </Space>
              )) ||
                null}
            </div>
          </Flex>

          {/* 表格 */}
          <Spin spinning={loading}>
            {Object.keys(tableData)?.map((type, index) => (
              <React.Fragment key={type}>
                <div className="table-title" style={{ marginTop: "20px" }}>
                  {type}
                </div>

                <EnhancedTable
                  columns={columns}
                  dataSource={tableData[type]}
                  scroll={{ x: "max-content", y: "calc(100vh - 350px)" }}
                />
              </React.Fragment>
            ))}
          </Spin>
     

        <AddModal
          ref={addModalRef}
          onSuccess={() => {
            fetchTable();
          }}
        />
        <EditModal
          ref={editModalRef}
          onSuccess={() => {
            fetchTable();
          }}
        />
      </Content>
    </div>
  );
}
